
export class NotaPraticaDTO {
    note: String;
  }
  